import { call, fork, put, select, takeLeading } from "redux-saga/effects";
import { callApi } from "../../Sagas/effects/callApi";
import { handleApiError } from "../../Sagas/effects/handleApiError";
import { setAccountSettings } from "../actions";
import { accountSettingsApi } from "../api/accountSettingsApi";
import { AccountSettingsActionsType } from "../const/actionsType";
import { AccountSettings, AccountSettingsResponseModel, AccountSettingsState } from "../reducers/accountSettings";

function* accountSettings() {
    const accountSettings: AccountSettings = yield select((state: AccountSettingsState) => state.accountSettings);
    if (!accountSettings) {
        try {
            const accountSettingsResponse: AccountSettingsResponseModel = yield callApi(() =>
                accountSettingsApi.getAccountSettings()
            );
            yield put(setAccountSettings(accountSettingsResponse));
        } catch (e) {
            yield call(handleApiError, e);
        }
    }
}

export function* watchGetAccountSettings() {
    yield takeLeading(AccountSettingsActionsType.LOAD_ACCOUNT_SETTINGS, accountSettings);
}

export function* accountSettingsRootSaga() {
    yield fork(watchGetAccountSettings);
}
